import { z } from "zod";
import { UuidSchema } from "./common.js";
/** Statut serveur & perf (R1, R20, R21). */
/** Joueur en ligne minimal (R1). */
export const OnlinePlayerSchema = z.object({
    uuid: UuidSchema,
    name: z.string(),
    ping: z.number().int().nonnegative().optional(),
});
export const OnlineResSchema = z.object({
    online: z.number().int().nonnegative(),
    max: z.number().int().nonnegative(),
    players: z.array(OnlinePlayerSchema),
});
/** Perf snapshot (R20). */
export const PerfSchema = z.object({
    tps: z.array(z.number()).length(3),
    mspt: z.object({
        average: z.number(),
        min: z.number().optional(),
        max: z.number().optional(),
        percentile95: z.number().optional(),
    }),
    memoryUsedMb: z.number().nonnegative(),
    memoryMaxMb: z.number().nonnegative(),
    gcCount: z.number().int().nonnegative().optional(),
    entities: z.number().int().nonnegative().optional(),
    chunks: z.number().int().nonnegative().optional(),
    tier: z.string().optional(),
});
/** Info serveur (R21). */
export const ServerInfoSchema = z.object({
    networkName: z.string(),
    serverId: z.string(),
    online: z.number().int().nonnegative(),
    max: z.number().int().nonnegative(),
    uptimeSeconds: z.number().int().nonnegative(),
    version: z.string(),
    worlds: z.array(z.string()),
});
/** Réponse combinée statut public. */
export const ServerStatusSchema = z.object({
    info: ServerInfoSchema,
    perf: PerfSchema,
});
// ── Carte live (Etheria_Map — proxy vers le serveur MC) ─────────────────────
/** Bordure d'un monde (centre + rayon), telle qu'appliquée en jeu. */
export const MapBorderSchema = z.object({
    centerX: z.number(),
    centerZ: z.number(),
    radius: z.number().nonnegative(),
});
/** Point d'apparition d'un monde. */
export const MapSpawnSchema = z.object({
    x: z.number(),
    y: z.number(),
    z: z.number(),
});
/** Un monde exposé par la carte (nom + bordure/spawn éventuels). */
export const MapWorldMetaSchema = z.object({
    name: z.string(),
    border: MapBorderSchema.optional(),
    spawn: MapSpawnSchema.optional(),
});
/**
 * Métadonnées de la carte live (Etheria_Map). Décrit ce que le front peut afficher/embarquer :
 * liste des mondes, chemin d'embed (iframe/tuiles), et disponibilité du service.
 * Alimente la page publique /carte et le panneau admin /admin/carte.
 */
export const MapMetaSchema = z.object({
    /** Mondes cartographiés. */
    worlds: z.array(MapWorldMetaSchema),
    /** Chemin/URL d'embed de la carte (relatif au BFF, ex « /map/ »). */
    embedPath: z.string().optional(),
    /** true si le service de carte répond. */
    available: z.boolean().default(true),
    /** Version du renderer de carte (optionnel). */
    version: z.string().optional(),
});
/** Type de point d'intérêt de la carte. */
export const MAP_POI_TYPES = ["warp", "shop", "claim", "boss", "event", "poi"];
export const MapPoiTypeSchema = z.enum(MAP_POI_TYPES);
/**
 * Corps d'action POI carte (admin, proxy Map). `remove=true` retire le POI ciblé par `id`.
 * Aligné sur l'interface `MapPoiReq` du web (api/admin.ts) — désormais typée ici.
 */
export const MapPoiReqSchema = z.object({
    id: z.string().optional(),
    type: z.string(),
    world: z.string(),
    x: z.number(),
    z: z.number(),
    label: z.string().optional(),
    remove: z.boolean().optional(),
});
/** Corps d'action bordure/spawn du monde (admin, proxy Map). */
export const MapWorldReqSchema = z.object({
    world: z.string(),
    border: MapBorderSchema.optional(),
    spawn: MapSpawnSchema.optional(),
});
//# sourceMappingURL=server.js.map